import { TruncatedTextWithTooltip } from '@app/components/base/TruncatedTextWithTooltip';
import { ApplyColumnFilter } from '@app/components/table/ApplyColumnFilter';
import { advertiserFieldMessage } from '@app/modules/audit/modules/station-audit/components/AdvertiserField';
import { campaignFieldMessage } from '@app/modules/audit/modules/station-audit/components/CampaignField';
import { orderFieldMessage } from '@app/modules/audit/modules/station-audit/components/OrderField';
import { versionFieldMessage } from '@app/modules/audit/modules/station-audit/components/VersionField';
import { AuditSchedule } from '@mi-front/core';
import { MRT_ColumnDef } from 'material-react-table';
import { IntlFormatters } from 'react-intl';

/**
 * Advertiser, campaign, version and order columns shared by spot/mentions schedule lists.
 */
export function createScheduleMetadataColumns(
  $t: IntlFormatters['$t'],
): MRT_ColumnDef<AuditSchedule>[] {
  return [
    {
      id: 'advertiser',
      header: $t(advertiserFieldMessage),
      size: 150,
      accessorFn: (schedule) => schedule.advertiser ?? '',
      Cell: ({ row }) => (
        <ApplyColumnFilter field="advertiser" value={row.original.advertiser}>
          <TruncatedTextWithTooltip value={row.original.advertiser} />
        </ApplyColumnFilter>
      ),
    },
    {
      id: 'campaign',
      header: $t(campaignFieldMessage),
      size: 150,
      accessorFn: (schedule) => schedule.campaign ?? '',
      Cell: ({ row }) => (
        <ApplyColumnFilter field="campaign" value={row.original.campaign}>
          <TruncatedTextWithTooltip value={row.original.campaign} />
        </ApplyColumnFilter>
      ),
    },
    {
      id: 'version',
      header: $t(versionFieldMessage),
      size: 150,
      accessorFn: (schedule) => schedule.version ?? '',
      Cell: ({ row }) => (
        <ApplyColumnFilter field="version" value={row.original.version}>
          <TruncatedTextWithTooltip value={row.original.version} />
        </ApplyColumnFilter>
      ),
    },
    {
      id: 'order',
      header: $t(orderFieldMessage),
      size: 100,
      accessorFn: (schedule) => schedule.order ?? '',
      Cell: ({ row }) => (
        <ApplyColumnFilter field="order" value={row.original.order}>
          <TruncatedTextWithTooltip value={row.original.order} />
        </ApplyColumnFilter>
      ),
    },
  ];
}
